import React from 'react';
import error from '../../img/404-error.jpg'
import './NotFound.css'

const NotFound = () => {
    return (
        <div className='not-found'>
            <img src={error} alt="error" />
        </div>
    );
}

export default NotFound;
